/* @flow */
import { lap } from '@braindate/ui/lib/token/mediaQuery';

import { dialogElevation } from 'src/shared/app/base/style/token/elevation';
import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';
import { mobileBarHeight } from 'src/shared/app/nav/style/nav.style';

export default {
  root: {
    position: 'fixed !important',
    boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.15)',
    width: 58,
    height: 58,
    right: 15,
    bottom: 26 + mobileBarHeight,
    zIndex: dialogElevation + 1,

    [lap]: {
      right: 42,
      bottom: 20,
      width: 74,
      height: 74,
    },
  },
  icon: {
    color: ({ theme }: ThemeFunction) => theme.accentColor,
    width: '29px !important',
    height: '29px !important',

    [lap]: {
      width: '36px !important',
      height: '36px !important',
    },
  },
};
